import StartScreenOptionsContainer from './StartScreenOptionsContainer';

export default StartScreenOptionsContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/StartScreenOptions/index.js